import { ProjectDocRepository } from "./ProjectDocRepository";

interface DesignItemLike {
  id: string;
  type: "photo" | "link";
  imageUrl: string;
  caption?: string;
  tags: string[];
  createdAt: number;
  storagePath?: string;
  sourceUrl?: string;
  title?: string;
  [key: string]: unknown;
}

class DesignItemRepository extends ProjectDocRepository<DesignItemLike[]> {
  readonly key = "design-items";
  readonly defaultValue: DesignItemLike[] = [];
}

export const designItemRepository = new DesignItemRepository();
